jQuery(document).ready(function ($) {

  /* ── Product popup accordions ─────────────────────────────────────────
     Rendered by sections/main-product.liquid behind the "Enable popup
     accordion" block setting. Opening one closes the others. */
  $('.popup_accordion_title').on('click', function () {
    var $accordion = $(this).closest('.popup_accordion');

    if ($accordion.hasClass('active')) {
      $accordion.removeClass('active');
      $accordion.find('.popup_accordion_content').slideUp();
      return;
    }

    $('.popup_accordion').removeClass('active');
    $('.popup_accordion_content').slideUp();
    $accordion.addClass('active');
    $accordion.find('.popup_accordion_content').slideDown();
  });

  /* ── Smooth scroll for in-page anchors ────────────────────────────────
     Delegated, so it binds nothing at load and needs no element to exist —
     which is what makes it incapable of the crash it replaces. Covers any
     anchor rather than two hardcoded ones. The 150px offset is the original
     value and clears the sticky header. */
  $(document).on('click', 'a[href^="#"]', function (e) {
    var id = $(this).attr('href').slice(1);
    if (!id) return;                    // a bare "#" has no target
    var target = document.getElementById(id);
    if (!target) return;                // nothing to scroll to; leave it alone

    e.preventDefault();
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - 150,
      behavior: 'smooth'
    });
  });

  /* ── Product card image flip, mobile only ─────────────────────────────
     The icon is hidden above 768px by product-flip-icon.liquid's own CSS,
     and only renders when the product carries the image_flip_icon
     metafield. */
  $('.product-card .product-flip-icon img.primary_icon').on('click', function () {
    var card = $(this).closest('.product-card');
    card.find('.product-primary-image').css('opacity', '0');
    card.find('.product-secondary-video').css('opacity', '1');
    card.find('.product-secondary-image').css('opacity', '1');
    $(this).hide();
    card.find('.secondary_icon').show();
  });

  $('.product-card .product-flip-icon img.secondary_icon').on('click', function () {
    var card = $(this).closest('.product-card');
    card.find('.product-primary-image').css('opacity', '1');
    card.find('.product-secondary-video').css('opacity', '0');
    card.find('.product-secondary-image').css('opacity', '0');
    $(this).hide();
    card.find('.primary_icon').show();
  });

});
